import { render, staticRenderFns } from "./ClassMenu.vue?vue&type=template&id=bcdc2df4&scoped=true"
import script from "./ClassMenu.vue?vue&type=script&lang=js"
export * from "./ClassMenu.vue?vue&type=script&lang=js"
import style0 from "./ClassMenu.vue?vue&type=style&index=0&id=bcdc2df4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdc2df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcdc2df4')) {
      api.createRecord('bcdc2df4', component.options)
    } else {
      api.reload('bcdc2df4', component.options)
    }
    module.hot.accept("./ClassMenu.vue?vue&type=template&id=bcdc2df4&scoped=true", function () {
      api.rerender('bcdc2df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/ClassMenu.vue"
export default component.exports